export default __webpack_public_path__ + "static/media/2019-1.97d3721a.jpeg";